import { isDefined } from '@sgme/fp';
import classNames from 'classnames';
import { IntlKey } from 'locales';
import { BaseSyntheticEvent, ReactNode } from 'react';
import { useIntl } from 'react-intl';

interface LearnMoreButtonProps {
  labelId: IntlKey;
  icon?: string | ReactNode;
  iconOnly?: true;
  variant: 'flat-primary' | 'flat-secondary' | 'link';
  onClick(): void;

  iconClassName?: string;
}

function dontPropagate<E extends BaseSyntheticEvent>(callback: () => void) {
  return function unpropagatedCallback(event: E) {
    event.stopPropagation();
    callback();
  };
}

export function LearnMoreButton({ labelId, icon, iconOnly, variant, onClick, iconClassName }: LearnMoreButtonProps) {
  const { formatMessage } = useIntl();
  const label = formatMessage({ id: labelId });
  return (
    <button
      type="button"
      className={classNames(
        'text-nowrap btn',
        `btn-${variant}`,
        isDefined(icon) ? `btn-icon${iconOnly ? '' : '-end'}` : '',
      )}
      title={iconOnly ? label : undefined}
      aria-label={iconOnly ? label : undefined}
      onClick={dontPropagate(onClick)}
    >
      {iconOnly ? null : label}
      {typeof icon === 'string' ? <i className={classNames('icon', iconClassName)}>{icon}</i> : icon}
    </button>
  );
}
